@if(isLoading) {
  <loading-animation [loadingMessage]="''"></loading-animation>
}
<div class="form-header-wrapper">
  <h2 class="form-header-text">Verification Code Sent</h2>
  <span><strong>{{email}}</strong></span>
  <div>
    <span>Please enter the code that was sent to your email.</span>
  </div>
</div>
<form (ngSubmit)="onSubmit()">
  @if(verificationResult !== 'SUCCESS' && failedAttempt) {
    <div>
      <div class="alert alert-danger" role="alert">
        <div style="display: flex;">
          <div style="padding-right: 1rem;"><mat-icon>error</mat-icon></div>
          <span>
            @if(unsuccessfulLoginCounter < 2) {
                An error occurred while trying to log in. Please check that the confirmation code we e-mailed to you is correct and try again.
            } @else if (unsuccessfulLoginCounter == 2) {
                <b>Two</b> attempts remaining. Please check that the confirmation code we e-mailed to you is correct and try again.
            } @else if (unsuccessfulLoginCounter == 3) {
                <b>One</b> attempt remaining before account is disabled. Please check that the confirmation code we e-mailed to you is correct and try again.
            } @else if (unsuccessfulLoginCounter > 3) {
                For security reasons, this account is temporarily disabled for <span><b>{{remainingLockoutTime}}</b></span> seconds.
            }
          </span>
        </div>
      </div>
    </div>
  }


  <br>
  <div class="verification-wrapper">
    <mat-form-field appearance="outline">
      <mat-label>Verification Code</mat-label>
      <input autofocus autocomplete="off"
             type="text" matInput
             id="verificationCode"
             name="verificationCode"
             [readonly]="isLoading"
             [(ngModel)]="oneTimePasscodeInput"
             maxlength="45"
             #verifyInput>
    </mat-form-field>
  </div>
  <div id="content--dont-ask">
    <mat-checkbox id="dontAskCheckBox"
                  name="dontAskCheckBox"
                  [(ngModel)]="dontAskCheckBox">
      Don&rsquo;t ask for codes again on this computer.
    </mat-checkbox>
  </div>
  <div class="buttons-wrapper">
    <div class="button-group-full-width">
      <button mat-flat-button
              color="primary"
              [disabled]="isLoading || !oneTimePasscodeInput"
              type="submit">
        <span>Verify</span>
      </button>
      <button mat-stroked-button
              color="primary"
              [disabled]="isResendAttemptUsed || isLoading"
              (click)="onResend()"
              type="button">
        <span>Resend</span>
      </button>
    </div>
  </div>
</form>

<util-message
  [displayType]="'SNACKBAR'"
  [message]="errorMessage"
  [duration]="5000"
  [animationTrigger]="errorMessage ? 'INVALID' : 'VALID'" >
</util-message>
<util-message
  [displayType]="'SNACKBAR'"
  [message]="successMessage"
  [messageType]="'SUCCESS'"
  [duration]="5000"
  [animationTrigger]="successMessage ? 'INVALID' : 'VALID'">
</util-message>
